import React, { useEffect } from 'react';
import { Alert, Icon } from 'vetrf-ui';
import styles from './Page404.module.scss';

export const Page404 = () => {
  useEffect(() => {
    if (window.location.pathname === '/react/') {
      window.location.replace(
        window.location.hash
          ? `${window.location.origin}/${window.location.hash}`
          : window.location.origin
      );
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      {window.location.pathname !== '/react/' && (
        <Alert messageType="danger">
          <Icon icon="exclamation-circle" className="fa-fw" />
          <span>Страница не найдена. Ошибка 404. </span>
          <a href={window.location.origin}>Перейти на главную страницу.</a>
        </Alert>
      )}
    </div>
  );
};
